"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFromContentfulModel = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderFromContentfulModel = function renderFromContentfulModel(_ref, item) {
  var _item$sys;

  var componentMap = _ref.componentMap;
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var parentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var type = item.__typename; // __typename must be defined in order to support mapping in componentMap

  if (!type) {
    console.warn('Undefined Type: \'{__typename}\' not specified on Entry data');
    return null;
  } // Check to make sure the specified type exists within the componentMap


  if (!Object.keys(componentMap).includes(type)) {
    console.warn("Undefined Type: '".concat(type, "' not defined in componentMap"));
    return null;
  } // Check to make sure the Contentful entry data includes `sys.id`, if not probably due to an imcomplete GraphQL query


  if (!(item === null || item === void 0 ? void 0 : (_item$sys = item.sys) === null || _item$sys === void 0 ? void 0 : _item$sys.id)) {
    console.warn('Incomplete Data: \'sys.id\' missing from Entry data', item);
    return null;
  }

  var key = "".concat(parentId, "_").concat(item.sys.id, "_").concat(index);
  return componentMap[type](_objectSpread(_objectSpread({}, item), {}, {
    key: key,
    componentMap: componentMap
  }), index);
};

exports.renderFromContentfulModel = renderFromContentfulModel;